<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h2 class="u">
      Дома
      <span v-if="total">({{ total }})</span>
      <router-link class="btn btn-primary" :to="{ name: 'building-add' }">+ Добавить дом</router-link>
    </h2>

    <resource-list
      url="/buildings"
      current-sort="number"
      init-sort-type="asc"
      resource-name="buildings"
      :show-per-page="false"
      :action-routes="actionRoutes"
      :fields="fields"
      :filters="filters"
      @total="updateTotal"
    />

  </div>
</template>

<script>
import resourceList from '@/components/ResourceList'

export default {
  name: 'buildings',
  components: { resourceList },
  data () {
    return {
      total: null,
      fields: [
        { name: 'full_name', label: 'Полный адрес', sort: false },
        { name: 'number', label: '№ дома', sort: true },
        { name: 'blocks_count', label: 'Кол-во подъездов', sort: false },
        { name: 'apartments_count', label: 'Кол-во квартир', sort: false }
      ],
      filters: {
        address: this.$route.params.address_id
      },
      actionRoutes: [
        { name: 'building-details', idName: 'building_id', label: 'Открыть детали' }
      ]
    }
  },
  methods: {
    updateTotal (val) {
      this.total = val
    }
  }
}
</script>


// WEBPACK FOOTER //
// Buildings.vue?7a5febd2